<mat-card *ngIf="myAgentsStatService" class="backspace title">
    <mat-card-title class="statsbg">Stats Agency: {{date | date:(year ? 'yyyy' : 'MMM') }}
        </mat-card-title>

    <mat-list>
        <mat-list-item style="border-bottom: 1px solid #e0e0e0;">
            <mat-icon matListIcon>functions</mat-icon>
            <div class="agentsStats">
                <div>
                    <mat-icon matListIcon [ngClass]="{'active': (year ? myAgentsStatService.totalYear.sales : myAgentsStatService.total.sales), 'warm': !(year ? myAgentsStatService.totalYear.sales : myAgentsStatService.total.sales)}">
                        {{GLOBAL.ICONS.DOLLAR}}
                    </mat-icon>
                    <span> {{(year ? myAgentsStatService.totalYear.sales : myAgentsStatService.total.sales) || 0 | number}}</span>
                </div>
                <div>
                    <mat-icon matListIcon
                        [ngClass]="{'active': (year ? myAgentsStatService.totalYear.nbDeals : myAgentsStatService.total.nbDeals), 'warm': !(year ? myAgentsStatService.totalYear.nbDeals : myAgentsStatService.total.nbDeals)}">{{GLOBAL.ICONS.DEAL}}</mat-icon>
                    <span> {{(year ? myAgentsStatService.totalYear.nbDeals : myAgentsStatService.total.nbDeals) || 0}}</span>
                </div>
                <div>
                    <mat-icon matListIcon
                        [ngClass]="{'active': (year ? myAgentsStatService.totalYear.mandates : myAgentsStatService.total.mandates), 'warm': !(year ? myAgentsStatService.totalYear.mandates : myAgentsStatService.total.mandates)}">{{GLOBAL.ICONS.MANDATEADD}}</mat-icon>
                    <span>{{(year ? myAgentsStatService.totalYear.mandates : myAgentsStatService.total.mandates) || 0}}</span>
                </div>
                <div>
                    <mat-icon matListIcon
                        [ngClass]="{'active': (year ? myAgentsStatService.totalYear.projects : myAgentsStatService.total.projects), 'warm': !(year ? myAgentsStatService.totalYear.projects : myAgentsStatService.total.projects)}">{{GLOBAL.ICONS.NEWREQUEST}}</mat-icon>
                    <span>{{(year ? myAgentsStatService.totalYear.projects : myAgentsStatService.total.projects) || 0}}</span>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item *ngFor="let stat of myAgentsStatService[year ? 'statListYear' : 'statList']">
            <img matListAvatar [src]="stat.realtor | realtor" [matTooltip]="stat.realtor | realtorName" />
            <div class="agentsStats">
                <div>
                    <mat-icon matListIcon [ngClass]="{'active': stat.sales?.all, 'warm': !stat.sales?.all}">
                        {{GLOBAL.ICONS.DOLLAR}}
                    </mat-icon>
                    <span> {{stat.sales?.all || 0 | number}}</span>
                </div>
                <div>
                    <mat-icon matListIcon
                        [ngClass]="{'active': stat.nbDeals?.all, 'warm': !stat.nbDeals?.all}">{{GLOBAL.ICONS.DEAL}}</mat-icon>
                    <span> {{stat.nbDeals?.all || 0}}</span>
                </div>
                <div>
                    <mat-icon matListIcon
                        [ngClass]="{'active': stat.mandateOrigins?.all, 'warm': !stat.mandateOrigins?.all}">{{GLOBAL.ICONS.MANDATEADD}}</mat-icon>
                    <span>{{stat.mandateOrigins?.all || 0}}</span>
                </div>
                <div>
                    <mat-icon matListIcon
                        [ngClass]="{'active': stat.projectOrigins?.all, 'warm': !stat.projectOrigins?.all}">{{GLOBAL.ICONS.NEWREQUEST}}</mat-icon>
                    <span>{{stat.projectOrigins?.all || 0}}</span>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</mat-card>
